import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import Textarea from '../../../components/forms/Textarea'
import { getYear } from '../../../utils/DateUtil'
import { CHIM_STATE, getChimStateLabels, getStateLabels, getStateLabelsNoCode } from '../../../utils/QualityUtils'
import QualityAction from '../../actions/QualityAction'
import DtoQualitometerState from '../../dto/states/DtoQualitometerState'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { useParams } from 'react-router'
import { keys } from 'lodash'
import { SHOW_SANDRE_CODE } from 'account/constants/AccountSettingsConstants'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'

const QualitometerStateModal = ({
    qualitometerState,
    isOpen = false,
    setIsOpen,
    isNew,
    readMode,
}) => {
    const dispatch = useDispatch()

    const { id } = useParams()

    const {
        qualityStates,
    } = useSelector(store => ({
        qualityStates: store.QualityReducer.qualityStates,
    }), shallowEqual)

    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)

    const [state, setState] = useState(qualitometerState)

    useEffect(() => {
        setState(qualitometerState)
    }, [qualitometerState])

    const updateState = () => {
        dispatch(QualityAction.updateQualitometerState({ qualitometer: parseInt(id), ...state })).then(() => {
            dispatch(QualityAction.fetchQualitometerStates(id))
            setIsOpen(false)
        })
    }

    const createState = () => {
        dispatch(QualityAction.createQualitometerState({ qualitometer: parseInt(id), ...state })).then(() => {
            dispatch(QualityAction.fetchQualitometerStates(id))
            setIsOpen(false)
        })
    }

    const deleteState = () => {
        dispatch(QualityAction.deleteQualitometerState({ qualitometer: parseInt(id), ...state })).then(() => {
            dispatch(QualityAction.fetchQualitometerStates(id))
            setIsOpen(false)
        })
    }

    const onChange = (changes) => setState(prev => ({ ...prev, ...changes }))

    const valueList = keys(getStateLabels()).map(key => ({ code: parseInt(key), name: showSandreCode ? getStateLabels()[key].value : getStateLabelsNoCode()[key].value }))
    const chimValueList = keys(getChimStateLabels()).map(key => ({ code: parseInt(key), name: showSandreCode ? getStateLabels()[key].value : getStateLabelsNoCode()[key].value }))
    return (
        <Dialog open={isOpen} maxWidth='md'>
            <DefaultDialogTitle title={i18n.editState} onClose={() => setIsOpen(false)}/>
            <DialogContent>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid size={6}>
                                <Select
                                    options={ qualityStates }
                                    value={ state.stateId }
                                    disabled={ !isNew }
                                    label={ i18n.state }
                                    onChange={ v => onChange({ stateId: v }) }
                                    readMode={readMode}
                                />
                            </Grid>
                            <Grid size={3}>
                                <NumberField
                                    title={ i18n.year }
                                    value={ getYear(state.startDate) }
                                    disabled={ !isNew }
                                    onChange={ v => v && onChange({ startDate: moment().year(v).valueOf() }) }
                                    readMode={readMode}
                                />
                            </Grid>
                            <Grid size={3}>
                                <Select
                                    options={ state.stateId === CHIM_STATE ? chimValueList : valueList }
                                    label={ i18n.value }
                                    onChange={ v => onChange({ value: v }) }
                                    value={ state.value }
                                    readMode={readMode}
                                />
                            </Grid>
                            <Grid size={12}>
                                <Textarea
                                    title={ i18n.comment }
                                    onChange={ v => onChange({ comment: v }) }
                                    value={ state.comment }
                                    readMode={readMode}
                                />

                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                {
                    isNew && (
                        <Button onClick={createState} variant='contained' >
                            {i18n.create}
                        </Button>
                    )
                }
                {
                    !readMode && !isNew && (
                        <Grid container spacing={2}>
                            <Button onClick={deleteState} variant='contained' className='red' style={{ color: 'white' }} >
                                {i18n.delete}
                            </Button>
                            <Button onClick={updateState} variant='contained' >
                                {i18n.register}
                            </Button>
                        </Grid>
                    )
                }
            </DialogActions>
        </Dialog>
    )
}

QualitometerStateModal.propTypes = {
    qualitometerState: PropTypes.instanceOf(DtoQualitometerState),
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    isNew: PropTypes.bool,
    readMode: PropTypes.bool,
}

export default QualitometerStateModal